<!------------------------------------------------------------------------------
  - Copyright (c) 2019. BMW Group. All rights reserved.
  ----------------------------------------------------------------------------->

<app-generic-modal (primaryActionEvent)="save()"
                   [primaryActionEnabled]="isValid"
                   [primaryActionTitle]="primaryActionTitle"
                   [title]="title"
                   secondaryActionTitle="Discard">
    <div class="business-modal-body">
        <app-input-text #reasonName
                        (inputValueChange)="nameInputChange($event)"
                        [messages]="nameMessages"
                        [validators]="validators.name"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-reason-modal-name"
                        label="Reason name"
                        maxLength="100"
                        placeholder="Please, write a reason name"></app-input-text>
        <app-input-text #reasonCode
                        (inputValueChange)="codeInputChange($event)"
                        [messages]="codeMessages"
                        [validators]="validators.code"
                        [warningLevel]="WarningsEnum.WARNING_SAVE"
                        baseCypressTag="business-settings-reason-modal-code"
                        label="Reason code"
                        maxLength="3"
                        placeholder="Please, write a reason code, e.g. AX3"></app-input-text>

        <app-active-input (checkState)="setActiveInputState($event)" [entityName]="ENTITY_NAME"
                          [state]="$safeNavigationMigration(state?.isActive)"></app-active-input>
    </div>
</app-generic-modal>
